import React, { useContext, useReducer } from "react";

const surveyContext = React.createContext();

const initialValue = {
    surveyList: null,
    surveyQue: null,
    answeredQues: null,
    loader: false,
    err: false,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SURVEY_LIST": {
            return { ...state, surveyList: action.payload, loader: false };
        }
        case "SURVEY_QUES": {
            return { ...state, surveyQue: action.payload, loader: false };
        }
        case "SURVEY_NAME": {
            return { ...state, surveyName: action.payload };
        }
        case "ANSWERED_QUES": {
            return { ...state, answeredQues: action.payload, loader: false, surveyQue: null };
        }
        case "SURVEY_REMOVE_QUE": {
            return { ...state, loader: false, surveyQue: null };
        }
        case "SURVEY_RESULT_ADDED": {
            return { ...state, loader: false, surveyQue: null };
        }
        case "SURVEY_ERR": {
            return { ...state, err: true, loader: false };
        }
        case "SURVEY_LOADER": {
            return { ...state, loader: true };
        }
        default:
            return state;
    }
};

export function SurveyProvider(props) {
    const [surveyC, dispatchSurvey] = useReducer(reducer, initialValue);
    return <surveyContext.Provider value={{ surveyC, dispatchSurvey }} {...props} />;
}

export function SurveyContext() {
    const context = useContext(surveyContext);
    if (!context) {
        throw new Error(" Please use the context inside parent scope");
    }
    return context;
}
